import React from 'react';
import { styled } from 'styled-components';

const Container = styled.details`
  padding: 0.5rem;
  & summary {
    font-weight: 800;
    border: 1px solid lightgray;
    border-radius: 0.3rem;
    padding: 0.2rem 0.5rem;
  }
`;

const Content = styled.div`
  padding: 1rem;
`;

export const Details = ({ summary, open, html, children }) => {
  return (
    <Container open={open}>
      <summary>{summary}</summary>
      {html ? <Content dangerouslySetInnerHTML={{ __html: html }} /> : children}
    </Container>
  );
};
